import { Button, Card } from "react-bootstrap";
import { CheckCircleIcon } from "@heroicons/react/outline";
import { Link } from "react-router-dom";
import { useAuth } from "../../services/wp.auth.service";

const PasswordVerificationSuccess = () => {
	const { user } = useAuth();

	return (
		<Card className="my-5">
			<Card.Body className="p-5 text-center">
				<div className="mt-4 mb-3">
					<CheckCircleIcon className="i i-4x text-green" />
				</div>

				<h3 className="text-blue mb-4">
					Congratulations!
				</h3>

				<p className="ms-auto me-auto" style={{ maxWidth: "400px" }}>
					You now have access to the Life With Cancer Class Registration System and can start registering for classes.
				</p>

				<div>
					{user?.attendeeDetails?.profileCompleted
						? null
						: <Button as={Link} to="/account/classes">Please Complete Your Profile</Button>}
				</div>
				<Button as={Link} to="/" variant="link">
					Proceed to Calendar
				</Button>
			</Card.Body>
		</Card>
	);
};

export default PasswordVerificationSuccess;
